<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <!-- Welcome Card -->
          <v-card class="card--shadow welcome-card" elevation="0">
            <v-card-text class="pa-8">
              <div class="welcome-content">
                <div class="welcome-header">
                  <v-icon class="welcome-icon" color="#aa00ff" size="64">
                    mdi-account-circle
                  </v-icon>
                  <div class="welcome-text">
                    <h1 class="welcome-title">
                      Welcome back, DA Dashboard
                    </h1>
                    <p class="welcome-subtitle">
                      CBDRTBC DA Dashboard
                    </p>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <!-- Patients Card -->
        <!-- <v-col cols="12" md="4">
          <v-card
            class="card--shadow stat-card clickable-card"
            elevation="0"
            @click="goToPatients"
          >
            <v-card-text class="pa-6">
              <div class="stat-content">
                <v-icon class="stat-icon" color="#aa00ff" size="48">
                  mdi-account-group
                </v-icon>
                <div class="stat-details">
                  <h3 class="stat-label">Patients</h3>
                  <div class="stat-count">
                    <span class="count-number">{{ totalPatients || 0 }}</span>
                    <span class="count-label">Patients</span>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col> -->

        <!-- Volunteers Card -->
        <!-- <v-col cols="12" md="4">
          <v-card
            class="card--shadow stat-card clickable-card"
            elevation="0"
            @click="goToVolunteers"
          >
            <v-card-text class="pa-6">
              <div class="stat-content">
                <v-icon class="stat-icon" color="#ff6f00" size="48">
                  mdi-account-multiple
                </v-icon>
                <div class="stat-details">
                  <h3 class="stat-label">Volunteers</h3>
                  <div class="stat-count">
                    <span class="count-number">{{ totalVolunteers || 0 }}</span>
                    <span class="count-label">Volunteers</span>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col> -->

        <!-- Reports Card -->
        <!-- <v-col cols="12" md="4">
          <v-card
            class="card--shadow stat-card clickable-card"
            elevation="0"
            @click="goToReports"
          >
            <v-card-text class="pa-6">
              <div class="stat-content">
                <v-icon class="stat-icon" color="#00bfa5" size="48">
                  mdi-chart-line
                </v-icon>
                <div class="stat-details">
                  <h3 class="stat-label">Reports</h3>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col> -->
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {},
  computed: {
    ...mapState("Admin", ["admin"]),
    // ...mapState("Patient", ["patients", "totalPatients"]),
    // ...mapState("Volunteer", ["volunteers", "totalVolunteers"]),
  },
  // created() {
  //   this.fetchPatients();
  //   this.fetchVolunteers();
  // },
  // methods: {
  //   goToPatients() {
  //     this.$router.push("/patient/townships");
  //   },
  //   goToReports() {
  //     this.$router.push("/report");
  //   },
  //   goToVolunteers() {
  //     this.$router.push("/volunteer/townships");
  //   },
  //   async fetchPatients() {
  //     try {
  //       const params = { page: 1 };
  //       // Filter by township group for DA dashboard totals
  //       if (this.admin && this.admin.township_group_id) {
  //         params.township_group_id = this.admin.township_group_id;
  //       }
  //       await this.$store.dispatch("Patient/getPatients", params);
  //     } catch (error) {
  //       console.error("Error fetching patients:", error);
  //     }
  //   },
  //   async fetchVolunteers() {
  //     try {
  //       await this.$store.dispatch("Volunteer/getVolunteers");
  //     } catch (error) {
  //       console.error("Error fetching volunteers:", error);
  //     }
  //   },
  // },
};
</script>

<style scoped>
.welcome-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  border-left: 4px solid #aa00ff;
  border-radius: 12px;
}

.welcome-content {
  display: flex;
  align-items: center;
}

.welcome-header {
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
}

.welcome-icon {
  flex-shrink: 0;
}

.welcome-text {
  flex: 1;
}

.welcome-title {
  font-size: 32px;
  font-weight: 600;
  color: #424242;
  margin: 0 0 8px 0;
  letter-spacing: 0.5px;
}

.welcome-subtitle {
  font-size: 16px;
  color: #757575;
  margin: 0;
  font-weight: 400;
}

.stat-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  height: 100%;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(170, 0, 255, 0.15) !important;
}

.clickable-card {
  cursor: pointer;
}

.clickable-card:hover {
  background-color: #f8f9ff !important;
}

.stat-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.stat-icon {
  flex-shrink: 0;
}

.stat-details {
  flex: 1;
}

.stat-label {
  font-size: 20px;
  font-weight: 600;
  color: #424242;
  margin: 0 0 8px 0;
}

.stat-description {
  font-size: 14px;
  color: #757575;
  margin: 0;
}

.stat-count {
  margin: 12px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.count-number {
  font-size: 32px;
  font-weight: 700;
  color: #aa00ff;
  line-height: 1;
}

.count-label {
  font-size: 12px;
  color: #757575;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

@media (max-width: 960px) {
  .welcome-title {
    font-size: 24px;
  }

  .welcome-subtitle {
    font-size: 14px;
  }

  .welcome-header {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }

  .stat-content {
    flex-direction: column;
    text-align: center;
  }
}
</style>
